import CategoriesItemChairs from "./CategoriesItemChairs";
import Footer from "../Footer";
import Newsletter from "../Newsletter";

function Chairs() {
  return (
    <>
      <CategoriesItemChairs />
      <Newsletter />
      <Footer />
    </>
  );
}

export default Chairs;
